import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { viewsActions } from 'ducks/views';

const ViewsSenderContainer = ({ entityType, entityId, resendIntervalMS }) => {
	const dispatch = useDispatch();

	const sendViews = (type, id) => {
		if (type && id) {
			dispatch(viewsActions.sendViews({ entityType: type, entityId: id }));
		}
	};

	useEffect(() => {
		sendViews(entityType, entityId);
		if (resendIntervalMS) {
			const interval = setInterval(() => {
				sendViews(entityType, entityId);
			}, resendIntervalMS);
			return () => clearInterval(interval);
		}
	}, []);

	return null;
};

ViewsSenderContainer.propTypes = {
	entityType: PropTypes.string.isRequired,
	entityId: PropTypes.number.isRequired,
	resendInterval: PropTypes.number
};

export default ViewsSenderContainer;
